/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientAIAssistantReceptionPatientTypename = "PatientAIAssistantReceptionPatient" as const;

/**
 *
 * @export
 * @interface PatientAIAssistantReceptionPatient
 */
export interface PatientAIAssistantReceptionPatient {
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  addressLine1?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  addressLine2?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  dateOfBirth?: string;
  /**
   * 0 if the patient themselves
   * @type {number}
   * @memberof PatientAIAssistantReceptionPatient
   */
  familyAccountId?: number;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  gender?: PatientAIAssistantReceptionPatientGenderEnum;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  hasMedicineNotebook?: PatientAIAssistantReceptionPatientHasMedicineNotebookEnum;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  kanaFirstName?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  kanaLastName?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  lastName?: string;
  /**
   *
   * @type {number}
   * @memberof PatientAIAssistantReceptionPatient
   */
  patientId: number;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  tel?: string;
  /**
   *
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  wantsGeneric?: PatientAIAssistantReceptionPatientWantsGenericEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientAIAssistantReceptionPatient
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientAIAssistantReceptionPatientGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
} /**
 * @export
 * @enum {string}
 */
export enum PatientAIAssistantReceptionPatientHasMedicineNotebookEnum {
  None = "none",
  Paper = "paper",
  Digital = "digital",
  Yqb = "yqb",
} /**
 * @export
 * @enum {string}
 */
export enum PatientAIAssistantReceptionPatientWantsGenericEnum {
  None = "none",
  Want = "want",
  Consultation = "consultation",
}

export function PatientAIAssistantReceptionPatientFromJSON(json: any): PatientAIAssistantReceptionPatient {
  return PatientAIAssistantReceptionPatientFromJSONTyped(json, false);
}

export function PatientAIAssistantReceptionPatientFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientAIAssistantReceptionPatient {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientAIAssistantReceptionPatientTypename,

    addressLine1: !exists(json, "address_line1") ? undefined : json["address_line1"],
    addressLine2: !exists(json, "address_line2") ? undefined : json["address_line2"],
    dateOfBirth: !exists(json, "date_of_birth") ? undefined : json["date_of_birth"],
    familyAccountId: !exists(json, "family_account_id") ? undefined : json["family_account_id"],
    firstName: !exists(json, "first_name") ? undefined : json["first_name"],
    gender: !exists(json, "gender") ? undefined : json["gender"],
    hasMedicineNotebook: !exists(json, "has_medicine_notebook") ? undefined : json["has_medicine_notebook"],
    kanaFirstName: !exists(json, "kana_first_name") ? undefined : json["kana_first_name"],
    kanaLastName: !exists(json, "kana_last_name") ? undefined : json["kana_last_name"],
    lastName: !exists(json, "last_name") ? undefined : json["last_name"],
    patientId: json["patient_id"],
    postalCode: !exists(json, "postal_code") ? undefined : json["postal_code"],
    tel: !exists(json, "tel") ? undefined : json["tel"],
    wantsGeneric: !exists(json, "wants_generic") ? undefined : json["wants_generic"],
  };
}

export function PatientAIAssistantReceptionPatientToJSON(object?: PatientAIAssistantReceptionPatient | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    address_line1: value.addressLine1,
    address_line2: value.addressLine2,
    date_of_birth: value.dateOfBirth,
    family_account_id: value.familyAccountId,
    first_name: value.firstName,
    gender: value.gender,
    has_medicine_notebook: value.hasMedicineNotebook,
    kana_first_name: value.kanaFirstName,
    kana_last_name: value.kanaLastName,
    last_name: value.lastName,
    patient_id: value.patientId,
    postal_code: value.postalCode,
    tel: value.tel,
    wants_generic: value.wantsGeneric,
  };
}
